export default __webpack_public_path__ + "static/media/Priyansh_Gupta_CV.e401625d.pdf";